<template>
  <div class="centix-boolinput">
    <span class="holder-span" :id="inputId">
        <input
          ref="input"
          type="checkbox"
          class="col-form-checkbox"
          v-model="isChecked"
          :disabled="!isEnabled">
      </span>
  </div>
</template>

<script>
export default {
  name: 'BoolInput',
  props: {
    value: {
      required: true
    },
    isEnabled: {
      default: true
    },
    required: {
      default: false
    }
  },
  model: {
    prop: 'value',
    event: 'value-changed'
  },
  components: {},
  data() {
    return {
      hasFocus: false,
      hasError: false,
      lastError: '',
      checked: false
    };
  },
  mounted() {},
  methods: {},
  watch: {
    value() {
      this.checked = this.value;
    }
  },
  computed: {
    hasValue: function () {
      return this.selectedKeyLocal != null && this.selectedKeyLocal > 0;
    },
    showRequiredClass: function () {
      if (this.required && !this.hasValue) {
        return true;
      } else {
        return false;
      }
    },
    inputId() {
      return this._uid + 'inp';
    },
    isChecked: {
      get() {
        return this.checked;
      },
      set(newvalue) {
        this.checked = newvalue;
        this.$emit('value-changed', newvalue);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'styles/settings.scss';

.centix-boolinput {
  display: inline-block;
  width: 100%;
  input {
    width: auto;
  }
  .col-form-checkbox {
    margin-top: 0.75rem;
  }

  .model-state-error {
    color: $error;
  }
}
</style>
